import { takeLatest, call } from 'redux-saga/effects'

import { FETCH_GUIDES, DELETE_GUIDE, FETCH_SPECIFIC_GUIDE } from 'Actions/guides'
import { fetchGuides, deleteGuide, fetchSpecificGuide } from './helpers/guides'

export default function* appSaga() {
  yield takeLatest(FETCH_GUIDES, fetchGuides)
  yield takeLatest(DELETE_GUIDE, onDeleteGuide)
  yield takeLatest(FETCH_SPECIFIC_GUIDE, fetchSpecificGuide)
}

const onDeleteGuide = function* (action) {
  const { guideId } = action.payload
  yield call(deleteGuide, guideId)
}
